import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { handleApiErrors, InputType } from "../../Utils/Utils";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import DynamicService from "../../Services/DynamicService";
import { Link, useNavigate } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import Calanderimg from "../../assets/images/png/fi_12671954.png";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import DataProvider from "../../Utils/DataProvider";
import { AuthContext } from "../../Context/authContext";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import DistrictService from "../../Services/DistrictService";
import TalukaService from "../../Services/TalukaService";

const RegistrationListing = () => {
  const [data, setData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [searchDistrict, setSearchDistrict] = useState(null);
  const [searchTaluka, setSearchTaluka] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { user } = useContext(AuthContext);
  const [districts, setDistricts] = useState([]);
  const [filterDistricts, setFilterDistricts] = useState([]);
  const [resetDistrict, setResetDistrict] = useState(false);
  const [resetFilterDistrict, setResetFilterDistrict] = useState(false);
  const [selectedDistrictFilter, setSelectedDistrictFilter] = useState("");
  const [talukas, setTalukas] = useState([]);
  const [filterTalukas, setFilterTalukas] = useState([]);
  const [resetTaluka, setResetTaluka] = useState(false);
  const [resetFilterTaluka, setResetFilterTaluka] = useState(false);
  const [selectedTalukaFilter, setSelectedTalukaFilter] = useState("");

  const [selectedRegisterBy, setSelectedRegisterBy] = useState(null);
  const [details, setDetails] = useState(null);
  const navigate = useNavigate();

  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  const CustomDateInput = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="From"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );
  const CustomDateInputTo = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="To"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );

  const fetchData = async () => {
    try {
      const response = await DynamicService.getAllRegistrUsers(
        offset,
        limit,
        searchQuery || "",
        selectedDistrictFilter.name || "",
        selectedTalukaFilter || "",
        selectedRegisterBy || "",
        startDate,
        endDate
      );
      setData(response.UserData);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const getAllUsersWithoutPagination = async () => {
    try {
      const response = await DynamicService.getAllUsersWithoutPagination();
      setDataExport(response.data);
      // setAvailableDataCount(response.availableDataCount);
      
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteSingleUser = async (id) => {
    try {
      await DynamicService.deleteUser([id]);
      toast.success("User Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleuser = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.user_id);
          }
        });
      }
      await DynamicService.deleteUser(itemsToDelete);
      toast.success("Users Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
    getAllFilterDistricts();
    getAllUsersWithoutPagination()
  }, [offset, selectedRegisterBy]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (
        searchQuery != null ||
        selectedDistrictFilter != null ||
        selectedTalukaFilter != null
      ) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery, selectedDistrictFilter, selectedTalukaFilter]);

  useEffect(() => {
    const fetchUserDataByDate = () => {
      if (startDate || endDate) {
        fetchData(startDate, endDate);
      }
    };

    const timeoutId = setTimeout(fetchUserDataByDate, 500); // Debounce the request

    return () => clearTimeout(timeoutId); // Clear timeout if date changes again quickly
  }, [startDate, endDate]);

  const removeTimeFromDate = (dateString) => {
    if (!dateString) return "";
    const dateObject = new Date(dateString);
    // Ensure the date is parsed as UTC
    const utcYear = dateObject.getUTCFullYear();
    const utcMonth = dateObject.toLocaleString("default", {
      month: "long",
      timeZone: "UTC",
    });
    const utcDay = dateObject.getUTCDate();
    return `${utcDay} ${utcMonth} , ${utcYear}`;
  };

  const exportToExcel = (data, fileName) => {
    console.log(data,'data')
    if (!data || data.length === 0) {
      toast.info("No data to export");
      return;
    }

    // Create a worksheet from data
    const ws = XLSX.utils.json_to_sheet(data);

    // Define the grand total row
    const grandTotalRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Grand Total",
    ];

    // Add grand total row to the end of the sheet
    XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 });

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to file
    XLSX.writeFile(wb, fileName);
  };

  const handleExportClick = () => {
    const name = user.name || "";
    const fileName = `${name} Student Data Report.xlsx`;
    exportToExcel(dataExport, fileName);
  };

  const getAllFilterDistricts = async (state_id = null) => {
    try {
      const response = await DistrictService.getAll(state_id);
      setFilterDistricts(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const getAllFilterTalukas = async (district_id) => {
    try {
      const response = await TalukaService.getAll(district_id);
      setFilterTalukas(district_id ? response.data : []);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  // Handle the change event and store the selected value
  const handleDropdownChange = (selectedOption) => {
    // Update state with the selected value from the dropdown
    setSelectedRegisterBy(selectedOption.value);
    setOffset(0);
  };

  // Find the option object based on the selected value
  const selectedOption = DataProvider.registeredBy.find(
    option => option.value === selectedRegisterBy
  );

  useEffect(() => {
    // Reset taluka when district changes
    if (resetFilterDistrict) {
      setSelectedTalukaFilter("");
      setResetFilterDistrict(false);
    }
  }, [resetFilterDistrict]);

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0 text-uppercase">
          {" "}
          Student Data Reports
        </h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">
            {" "}
            Registration Page Listing
          </h4>
        </div>
      </div>
      {details?.user_id ? (
        <div className="table_container">
          <h1 className="black fs-18 fw-600 mb-0">Registration Page Listing</h1>
          <div className=" fs-16 fw-600 mt-3 mb-3 blue">Personal Details</div>
          <div className="rounded shadow ">
            {" "}
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">
                  <tr>
                    <th style={{ width: "20%" }}>First Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.firstName}</td>
                    <th style={{ width: "20%" }}>Middle Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.middleName ? (
                        details.middleName
                      ) : (
                        <span className="blue">Not Available...</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>Last Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.lastName}</td>
                    <th style={{ width: "20%" }}>Date of Birth</th>
                    <td style={{ width: "20%" }}>
                      {removeTimeFromDate(details?.dateOfBirth)}
                    </td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Gender</th>
                    <td style={{ width: "20%" }}>{details?.gender}</td>
                    <th style={{ width: "20%" }}>School Name</th>
                    <td style={{ width: "20%" }}>{details?.schoolName}</td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Medium</th>
                    <td style={{ width: "20%" }}>{details?.medium}</td>
                    <th style={{ width: "20%" }}>Class</th>
                    <td style={{ width: "20%" }}>{details?.class_name}</td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Register By</th>
                    <td style={{ width: "20%" }}>{details?.registerBy}</td>
                    {details?.referralCode ? (
                      <th style={{ width: "20%" }}>Unique Code</th>
                    ) : null}
                    {details?.referralCode ? (
                      <td style={{ width: "20%" }}>{details?.referralCode}</td>
                    ) : null}
                  </tr>{" "}
                </thead>
              </table>
            </div>
          </div>
          <div className=" fs-16 fw-600 mt-3 mb-3 blue">Contact Details</div>
          <div className="rounded shadow ">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">
                  <tr>
                    <th style={{ width: "20%" }}>Email</th>
                    <td style={{ width: "20%" }}>{details?.email}</td>
                    <th style={{ width: "20%" }}>Mobile</th>
                    <td style={{ width: "20%" }}>{details?.mobile}</td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>Address Line-1 </th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.addressLineOne}</td>
                    <th style={{ width: "20%" }}>Address Line-2</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.addressLineTwo}</td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>State</th>
                    <td style={{ width: "20%" }}>{details?.state}</td>
                    <th style={{ width: "20%" }}>District</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.district}</td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Taluka</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>{details?.taluka}</td>
                    <th style={{ width: "20%" }}>Pin Code</th>
                    <td style={{ width: "20%" }}>{details?.pinCode}</td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <div className="d-flex justify-content-start">
            <div
              className="blue cursor-pointer mt-3 fw-500 fs-14"
              onClick={() => {
                setDetails(null); // Clear the details view
                // setSearchDistrict(""); // Reset District filter to an empty string
                // setSearchTaluka(""); // Reset Taluka filter to an empty string
                // setSearchQuery(""); // Reset Search Query if necessary
                // setOffset(0); // Reset offset to start from the beginning
                // Fetch all data again without filters
              }}
            >
              {" "}
              <Image src={SvgImages.left_arrow} className="blue mx-3" />
              Back
            </div>
          </div>
        </div>
      ) : (
      <div className="table_container" style={{ display: "block" }}>
        {/* <h1 className="black fs-18 fw-600 mb-0">Registration Page Listing</h1> */}

        <div className="table_title">
          <div className="table_headings ">
            <h1 className="black fs-18 fw-600 mb-0">
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                  pointerEvents:
                    data?.findIndex((item) => item.isChecked) === -1
                      ? "none"
                      : "auto",
                }}
                onClick={() => {
                  const reportsPrivilege = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Reports"
                  );
                  if (!reportsPrivilege?.delete) {
                    // If the user does not have delete permission, show a toast warning
                    toast.warning(
                      "You don't have permission to delete students."
                    );
                    return;
                  }

                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
            </h1>
            <div className="d-flex gap-4 align-items-center ">
              <div className="position-relative ">
                <input
                  type="search"
                  className="search_box search_bar"
                  placeholder="Search details"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <Image
                  src={SvgImages.search}
                  style={ImageFilters.gray}
                  className="search_icon"
                  alt="Search Icon"
                  height="20px"
                />
              </div>
            </div>
          </div>
        </div>

        <div className=" row table_title align-items-center responsivetablepackagetwo">
          <div className="col-lg-6 col-md-12 col-xl-3 gap-2 col-12 pe-0 d-flex  align-items-center sectionPayouts  datepickerstyle">
            <div className="">Date:</div>
            <div>
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                isClearable
                placeholderText="From"
                maxDate={new Date()}
                customInput={<CustomDateInput />}
              />
            </div>
            <div>
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                isClearable
                placeholderText="To"
                minDate={startDate}
                maxDate={new Date()}
                customInput={<CustomDateInputTo />}
              />
            </div>
          </div>
          <div className="col-xl-7 my-2 col-lg-12 col-md-12 gap-2 Responsivesearchbars  align-items-center d-flex">
            <div className="col-md-8 col-lg-4 col-sm-12">
              <CustomDropDown
                placeholder="Register By"
                inputType={InputType.text}
                labelClass="commissionsection"
                Dropdownclass="marginsection"
                options={DataProvider.registeredBy}
                value={selectedOption} 
                onChange={handleDropdownChange}
              />
            </div>

            <div className=" col-md-8 col-lg-4 col-sm-12 ">
             <CustomDropDown
                  placeholder="Select District"
                  inputType={InputType.text}
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  resetValue={resetFilterDistrict}
                  setResetValue={setResetFilterDistrict}
                  onChange={(e) => {
                    const selected = filterDistricts.find(d => d._id === e.value);
                    setSelectedDistrictFilter({
                      id: selected?._id || "",
                      name: selected?.name || "",
                    });
                    setResetFilterTaluka(true);
                    getAllFilterTalukas(selected?._id || ""); // Pass ID here
                    setSelectedTalukaFilter("");
                    setOffset(0);
                  }}
                  options={[
                    { value: "", label: "All" },
                    ...filterDistricts?.map((e) => ({
                      value: e._id,
                      label: e.name,
                    })) ?? [],
                  ]}
                  defaultOption={{ value: selectedDistrictFilter._id, label: selectedDistrictFilter.name || "Select District"  }}
                />
            </div>

            <div className="col-md-8 col-lg-4  col-sm-12">
            <CustomDropDown
                  placeholder="Select Taluka"
                  inputType={InputType.text}
                  resetValue={resetFilterTaluka}
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  setResetValue={setResetFilterTaluka}
                  onChange={(e) => {
                    setSelectedTalukaFilter(e.value);
                    setOffset(0);
                  }}
                  options={[
                    { value: "", label: "All" },
                    ...filterTalukas?.map((e) => {
                      return { value: e.name, label: e.name }
                    }) ?? []]}
                    defaultOption={{ value: selectedTalukaFilter, label: selectedTalukaFilter || "Select Taluka" }}
                />
            </div>
          </div>

          <div className="col-md-12  col-lg-12 col-xl-2  col-12 d-flex align-items-center justify-content-end respoexportbtn ">
            <ButtonWithIcon
              text={"Export"}
              icon={PngImages.xlspic}
              onClick={handleExportClick}
            />
          </div>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            className="table mb-0 "
            id="dtHorizontalExample"
            cellSpacing="0"
            width="100%"
          >
            <thead>
              <tr className="table_heading">
                <th scope="col" style={{ width: "5%" }}>
                  <label className="d-flex align-items-center justify-content-center">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      style={{ height: "16px", aspectRatio: 1 }}
                      checked={
                        data?.length > 0 &&
                        data?.findIndex((item) => !item.isChecked) == -1
                      }
                      onChange={(value) => {
                        var updatedData = data;
                        updatedData.map((element) => {
                          element.isChecked = value.target.checked;
                        });
                        setData([...updatedData]);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Sr No.
                </th>
                <th scope="col" style={{ width: "15%" }}>
                  Name
                </th>
                <th scope="col" style={{ width: "15%" }}>
                  Reg. Date
                </th>
                <th scope="col" style={{ width: "15%" }}>
                  Email
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  Mobile No.
                </th>
                <th scope="col" style={{ width: "20%" }}>
                  School Name
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  View{" "}
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg_light">
              {data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        checked={item.isChecked || false}
                        style={{ height: "16px", aspectRatio: 1 }}
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData[index].isChecked = value.target.checked;
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td>
                  <td>{limit * offset + (index + 1)}</td>
                  <td className="text-capitalize">
                    {item.firstName + " " + item.lastName}
                  </td>
                  <td>{removeTimeFromDate(item.registrationDate)}</td>
                  <td>{item.email}</td>
                  <td>{item.mobile}</td>
                  <td>{item.schoolName}</td>
                  <td>
                    <a
                      className="cursor-pointer"
                      onClick={() => {
                       setDetails(item);
                      }}
                    >
                      View
                    </a>
                  </td>
                  <td>
                    <div className="d-flex gap_8">
                    <a
                          onClick={() => {

                            const reportsPrivilege = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Reports"
                            );
                            if (!reportsPrivilege?.update) {
                              // If the user does not have delete permission, show a toast warning
                              toast.warning("You don't have permission to edit students.");
                              return;
                            }
                            navigate(
                              `${RoutesPath.editstudentdetails}/${item.user_id}`,
                              { state: item, }
                            );
                          }}
                          className="edit_icons cursor-pointer"
                          data-bs-target="#editclass"
                          data-bs-toggle="modal"
                        >
                          <Image
                            src={SvgImages.edit}
                            style={ImageFilters.green}
                            className="add_icons"
                            alt="Edit Icon"
                          />
                        </a>
                      <a
                        className="delete_icons cursor-pointer"
                        onClick={() => {
                          const reportsPrivilege = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Reports"
                          );
                          if (!reportsPrivilege?.delete) {
                            // If the user does not have delete permission, show a toast warning
                            toast.warning(
                              "You don't have permission to delete student."
                            );
                            return;
                          }

                          setDeleteId(item.user_id);
                          setIsMultipleDelete(false);
                          setShowDeleteModal(true);
                        }}
                      >
                        <Image
                          src={SvgImages.deleteIcon}
                          style={ImageFilters.red}
                          data-bs-target="#delete-modal"
                          data-bs-toggle="modal"
                          alt="Delete Icon"
                        />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {generatePaginationFooter(availableDataCount, limit, offset, setOffset)}
      </div>
      )}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected Users?"
            : "Are you sure want to delete User?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete ? deleteMultipleuser() : deleteSingleUser(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
    </div>
  );
};

export default RegistrationListing;
